<template>
  <div class="workcenter-page work-center-main" @click="closeContextMenu">
    <div class="workcenter-page__topbar">
      <div v-if="!isMobileOnly">
        <h1>Workcenter</h1>
        <div class="workcenter-page__breadcrumb">Home // View Workcenter</div>
      </div>
      <div class="workcenter-page__actions">
        <button v-if="!isMobileOnly" 
            type="button" class="btn btn-primary plus-btn-hover" @click="goToWorkflow">Workflow</button>
        <button type="button" class="btn btn-primary plus-btn-hover" @click="$router.push('/files/new')"><i class="bx bx-plus"></i> New Estimate</button>
          <div class="workcenter-page__global-search">
          <search-filter
              type="estimates"
              class="search-filter"
              style="padding-left: 13px"
              v-model="searchFilter"
              :limitLength="50"
              :filterValue="searchFilter"
              @selectAdditional="redirectToCardEdit"
              @onEnter="onEnter"
              :placeholder="'Search'"
              :additionalMenu="additionalMenu"
              :debug="false"
              height="41px"
              aria-expanded="false"
              data-toggle="dropdown"></search-filter>
        </div>
      </div>
    </div>

    <section v-if="!isMobileOnly" 
        class="workcenter-metrics-grid">
      <metric-widget
        v-for="metric in visibleMetrics"
        :key="metric.key"
        :title="metric.title"
        :value="metric.value"
        :suffix="metric.suffix"
        :badge="metric.badge"
        :color="metric.color"
        :options="metric.options"
        :selected-value="metric.selectedValue"
        @select="selectMetricOption(metric.key, $event)"
      />
    </section>

    <section class="workcenter-columns-grid">
      <workcenter-column
        title="My To Do List"
        :tabs="todoTabs"
        :active-tab="activeTodoTab"
        :search="todoSearch"
        @change-tab="activeTodoTab = $event"
        @search="todoSearch = $event"
      >
        <template v-if="activeTodoTab === 'tasks'">
          <div v-if="(tasks && tasks.length > 0)">
            <div v-if="computedTasks[navItem.key].length" v-for="navItem in tasksNav" :key="navItem.key">
              <div class="workcenter-card-navigation d-flex justify-content-between">
                <div @click="navItem.display = !navItem.display" :class="{'active': !navItem.display}">
                  <i class='bx bxs-chevron-down' style="position: relative; top: 4px"></i> {{ navItem.label }}
                </div>
                <div v-if="navItem.key == firstNotEmptyNav.tasks">
                  <i @click="isHideReadTasks = !isHideReadTasks" class='bx bx-task'></i>
                  <i @click="isSortTask = !isSortTask" class='bx bx-transfer'></i>
                </div>
              </div>
              <workcenter-card
                v-for="task in computedTasks[navItem.key]"
                :key="'task-' + task.id"
                :item="task"
                :title="task.title"
                :message="task.message"
                :date-label="task.dateLabel"
                :job-number="task.jobNumber"
                :tag="task.tag"
                :tag-color="task.tagColor"
                :icon="task.icon"
                :unread="isUnread(task)"
                v-show="!(task.isViewed && isHideReadTasks) && navItem.display"
                @click="handleCardClick(task)"
                @contextmenu="openContextMenu($event, task, 'task')"
              />
            </div>
          </div>
          <div v-else class="workcenter-empty">No tasks</div>
        </template>

        <template v-if="activeTodoTab === 'comments'">
          <div v-if="(comments && comments.length > 0)">
            <div v-if="computedComments[navItem.key].length" v-for="navItem in commentsNav" :key="navItem.key">
              <div class="workcenter-card-navigation d-flex justify-content-between">
                <div @click="navItem.display = !navItem.display" :class="{'active': !navItem.display}">
                  <i class='bx bxs-chevron-down' style="position: relative; top: 4px"></i> {{ navItem.label }}
                </div>
                <div v-if="navItem.key == firstNotEmptyNav.comments">
                  <i @click="isHideReadComments = !isHideReadComments" class='bx bx-message-rounded'></i>
                  <i @click="isSortComment = !isSortComment" class='bx bx-transfer'></i>
                </div>
              </div>
              <workcenter-card
                v-for="comment in computedComments[navItem.key]"
                :key="'comment-' + comment.id"
                :item="comment"
                :title="comment.title"
                :message="comment.message"
                :date-label="comment.dateLabel"
                :job-number="comment.jobNumber"
                :tag="comment.tag"
                :tag-color="comment.tagColor"
                :icon="comment.icon"
                :unread="isUnread(comment)"
                v-show="!(comment.isViewed && isHideReadComments) && navItem.display"
                @click="handleCardClick(comment)"
                @contextmenu="openContextMenu($event, comment, 'comment')"
              />
            </div>
          </div>
          <div v-else class="workcenter-empty">No comments</div>
        </template>

        <template v-if="activeTodoTab === 'files'">
          <div v-if="(cards && cards.length > 0)">
            <div v-if="computedCards[navItem.key].length" v-for="navItem in cardsNav" :key="navItem.key">
              <div class="workcenter-card-navigation d-flex justify-content-between">
                <div @click="navItem.display = !navItem.display" :class="{'active': !navItem.display}">
                  <i class='bx bxs-chevron-down' style="position: relative; top: 4px"></i> {{ navItem.label }}
                </div>
                <div v-if="navItem.key == firstNotEmptyNav.cards">
                  <i @click="isHideReadCards = !isHideReadCards" class='bx bx-file'></i>
                  <i @click="isSortCard = !isSortCard" class='bx bx-transfer'></i>
                </div>
              </div>
              <workcenter-card
                v-for="card in computedCards[navItem.key]"
                :key="'card-' + card.id"
                :item="card"
                :title="card.title"
                :message="card.message"
                :date-label="card.dateLabel"
                :job-number="card.jobNumber"
                :tag="card.tag"
                :tag-color="card.tagColor"
                :icon="card.icon"
                :unread="isUnread(card)"
                v-show="!(card.isViewed && isHideReadCards) && navItem.display"
                @click="handleCardClick(card)"
                @contextmenu="openContextMenu($event, card, 'card')"
              />
            </div>
          </div>
          <div v-else class="workcenter-empty">No files</div>
        </template>
      </workcenter-column>

      <workcenter-column
        title="Messages"
        :tabs="messageTabs"
        :active-tab="activeMessageTab"
        :search="messageSearch"
        @change-tab="activeMessageTab = $event"
        @search="messageSearch = $event"
      >
        <template v-if="activeMessageTab === 'insurers'" slot="filters">
          <div class="workcenter-insurer-filters">
            <button
              v-for="filter in insurerFilters"
              :key="filter.key"
              type="button"
              :class="[filter.className, { 'workcenter-filter--active': isInsurerFilterActive(filter.key) }]"
              @click="toggleInsurerFilter(filter.key)"
            >
              {{ filter.label }} <span>{{ filter.count }}</span>
            </button>
          </div>
        </template>

        <template v-if="activeMessageTab === 'emails'">
          <div v-if="(emails && emails.length > 0)">
            <div v-if="computedEmails[navItem.key].length" v-for="navItem in emailsNav" :key="navItem.key">
              <div class="workcenter-card-navigation d-flex justify-content-between">
                <div @click="navItem.display = !navItem.display" :class="{'active': !navItem.display}">
                  <i class='bx bxs-chevron-down' style="position: relative; top: 4px"></i> {{ navItem.label }}
                </div>
                <div v-if="navItem.key == firstNotEmptyNav.emails">
                  <i @click="isHideReadEmails = !isHideReadEmails" class='bx bx-envelope'></i>
                  <i @click="isSortEmail = !isSortEmail" class='bx bx-transfer'></i>
                </div>
              </div>
              <workcenter-card
                v-for="email in computedEmails[navItem.key]"
                :key="'email-' + email.id"
                :item="email"
                :title="email.title"
                :message="email.message"
                :date-label="email.dateLabel"
                :job-number="email.jobNumber"
                :tag="email.tag"
                :tag-color="email.tagColor"
                :icon="email.icon"
                :unread="isUnread(email)"
                v-show="!(email.isViewed && isHideReadEmails) && navItem.display"
                @click="handleCardClick(email)"
                @contextmenu="openContextMenu($event, email, 'email')"
              />
            </div>
          </div>
          <div v-else class="workcenter-empty">No emails</div>
        </template>

        <template v-if="activeMessageTab === 'sms'">
          <div v-if="(sms && sms.length > 0)">
            <div v-if="computedSMS[navItem.key].length" v-for="navItem in smsNav" :key="navItem.key">
              <div class="workcenter-card-navigation d-flex justify-content-between">
                <div @click="navItem.display = !navItem.display" :class="{'active': !navItem.display}">
                  <i class='bx bxs-chevron-down' style="position: relative; top: 4px"></i> {{ navItem.label }}
                </div>
                <div v-if="navItem.key == firstNotEmptyNav.sms">
                  <i @click="isHideReadSMS = !isHideReadSMS" class='bx bx-mobile-alt'></i>
                  <i @click="isSortSMS = !isSortSMS" class='bx bx-transfer'></i>
                </div>
              </div>
              <workcenter-card
                v-for="message in computedSMS[navItem.key]"
                :key="'sms-' + message.id"
                :item="message"
                :title="message.title"
                :message="message.message"
                :date-label="message.dateLabel"
                :job-number="message.jobNumber"
                :tag="message.tag"
                :tag-color="message.tagColor"
                :icon="message.icon"
                :unread="isUnread(message)"
                v-show="!(message.isViewed && isHideReadSMS) && navItem.display"
                @click="handleCardClick(message)"
                @contextmenu="openContextMenu($event, message, 'sms')"
              />
            </div>
          </div>
          <div v-else class="workcenter-empty">No SMS</div>
        </template>

        <template v-if="activeMessageTab === 'insurers'">
          <div v-if="(insurers && insurers.length > 0)">
            <div v-if="computedInsurers[navItem.key].length" v-for="navItem in insurersNav" :key="navItem.key">
              <div class="workcenter-card-navigation d-flex justify-content-between">
                <div @click="navItem.display = !navItem.display" :class="{'active': !navItem.display}">
                  <i class='bx bxs-chevron-down' style="position: relative; top: 4px"></i> {{ navItem.label }}
                </div>
                <div v-if="navItem.key == firstNotEmptyNav.insurers">
                  <i @click="isHideReadInsurers = !isHideReadInsurers" class='bx bx-detail'></i>
                  <i @click="isSortInsurers = !isSortInsurers" class='bx bx-transfer'></i>
                </div>
              </div>
              <workcenter-card
                v-for="insurer in computedInsurers[navItem.key]"
                :key="'insurer-' + insurer.id"
                :item="insurer"
                :title="insurer.title"
                :message="insurer.message"
                :date-label="insurer.dateLabel"
                :job-number="insurer.jobNumber"
                :tag="insurer.tag"
                :tag-color="insurer.tagColor"
                :icon="insurer.icon"
                :unread="isUnread(insurer)"
                v-show="!(insurer.isViewed && isHideReadInsurers) && navItem.display"
                @click="handleCardClick(insurer)"
                @contextmenu="openContextMenu($event, insurer, 'insurer')"
              />
            </div>
          </div>
          <div v-else class="workcenter-empty">No insurers</div>
        </template>
      </workcenter-column>

      <parts-tracker @contextmenu="openContextMenu" />
    </section>

    <context-menu
      :visible="contextMenu.visible"
      :x="contextMenu.x"
      :y="contextMenu.y"
      :isViewed="contextMenu && contextMenu.item ? contextMenu.item.isViewed: false"
      @mark-read="setReadState(true)"
      @mark-unread="setReadState(false)"
      @open="openItemInNewTab"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { mapGetters } from 'vuex'
import MetricWidget from './metric-widget'
import WorkcenterColumn from './workcenter-column'
import WorkcenterCard from './workcenter-card'
import PartsTracker from './parts-tracker'
import ContextMenu from './context-menu'
import SearchFilter from "@/components/search-filter/search-filter-2.vue";
import { isMobileOnly } from '@/deviceDetect'

dayjs.extend(customParseFormat)

export default {
  name: 'Workcenter',
  components: {
    SearchFilter,
    MetricWidget,
    WorkcenterColumn,
    WorkcenterCard,
    PartsTracker,
    ContextMenu
  },
  data() {
    return {
      isMobileOnly,
      searchFilter: '',
      todoSearch: '',
      messageSearch: '',
      activeTodoTab: 'tasks',
      activeMessageTab: 'insurers',
      activeInsurerFilters: [],
      selectedInspectionStatus: null,
      selectedWipPhase: null,
      localReadState: {},
      contextMenu: {
        visible: false,
        x: 0,
        y: 0,
        item: null,
        type: null
      },
      // Date filtering state
      isHideReadTasks: false,
      isSortTask: false,
      isHideReadComments: false,
      isSortComment: false,
      isHideReadCards: false,
      isSortCard: false,
      isHideReadEmails: false,
      isSortEmail: false,
      isHideReadSMS: false,
      isSortSMS: false,
      isHideReadInsurers: false,
      isSortInsurers: false,
      // Date navigation structures
      tasksNav: [
        { label: 'Today', key: 'today', display: true },
        { label: 'Yesterday', key: 'yesterday', display: true },
        { label: 'This week', key: 'thisWeek', display: true },
        { label: 'Last week', key: 'lastWeek', display: true },
        { label: 'This month', key: 'thisMonth', display: true },
        { label: 'Last month', key: 'lastMonth', display: true },
        { label: 'Older', key: 'older', display: true }
      ],
      commentsNav: [
        { label: 'Today', key: 'today', display: true },
        { label: 'Yesterday', key: 'yesterday', display: true },
        { label: 'This week', key: 'thisWeek', display: true },
        { label: 'Last week', key: 'lastWeek', display: true },
        { label: 'This month', key: 'thisMonth', display: true },
        { label: 'Last month', key: 'lastMonth', display: true },
        { label: 'Older', key: 'older', display: true }
      ],
      cardsNav: [
        { label: 'Today', key: 'today', display: true },
        { label: 'Yesterday', key: 'yesterday', display: true },
        { label: 'This week', key: 'thisWeek', display: true },
        { label: 'Last week', key: 'lastWeek', display: true },
        { label: 'This month', key: 'thisMonth', display: true },
        { label: 'Last month', key: 'lastMonth', display: true },
        { label: 'Older', key: 'older', display: true }
      ],
      emailsNav: [
        { label: 'Today', key: 'today', display: true },
        { label: 'Yesterday', key: 'yesterday', display: true },
        { label: 'This week', key: 'thisWeek', display: true },
        { label: 'Last week', key: 'lastWeek', display: true },
        { label: 'This month', key: 'thisMonth', display: true },
        { label: 'Last month', key: 'lastMonth', display: true },
        { label: 'Older', key: 'older', display: true }
      ],
      smsNav: [
        { label: 'Today', key: 'today', display: true },
        { label: 'Yesterday', key: 'yesterday', display: true },
        { label: 'This week', key: 'thisWeek', display: true },
        { label: 'Last week', key: 'lastWeek', display: true },
        { label: 'This month', key: 'thisMonth', display: true },
        { label: 'Last month', key: 'lastMonth', display: true },
        { label: 'Older', key: 'older', display: true }
      ],
      insurersNav: [
        { label: 'Today', key: 'today', display: true },
        { label: 'Yesterday', key: 'yesterday', display: true },
        { label: 'This week', key: 'thisWeek', display: true },
        { label: 'Last week', key: 'lastWeek', display: true },
        { label: 'This month', key: 'thisMonth', display: true },
        { label: 'Last month', key: 'lastMonth', display: true },
        { label: 'Older', key: 'older', display: true }
      ],
      // inspectionOptions removed - now computed from ceStatuses
      // phaseOptions removed - now computed from ceStatuses
    }
  },
  computed: {
    ...mapGetters({
      isDisplayBoardUser: 'isDisplayBoardUser',
      isShopManagerUser: 'isShopManagerUser',
      isProductionManagerUser: 'isProductionManagerUser',
      isEstimatorUser: 'isEstimatorUser',
      isCustomerUser: 'isCustomerUser',
      tasks: 'dashboard/getTasks',
      comments: 'dashboard/getComments',
      emails: 'dashboard/getEmails',
      sms: 'dashboard/getSms',
      insurers: 'dashboard/getInsurers',
      cards: 'card/getCardsAssignedToMe',
      cardsAll: 'card/getAllCards',
      ceStatuses: 'ceStatuses',
      getAllEstimates: 'estimate/getAllEstimates',
      vendorInfo: 'vendorInfo',
      vendorId: 'vendorId',
      bookingItems: 'board/getBookingItems',
    }),
    inspectionStorageKey() {
      return `workcenter.metric.inspections_today.${this.vendorId || 'default'}`;
    },
    wipStorageKey() {
      return `workcenter.metric.wip.${this.vendorId || 'default'}`;
    },
    canViewAdvancedMetrics() {
      return this.isShopManagerUser || this.isProductionManagerUser || this.isEstimatorUser || this.isCustomerUser
    },
    additionalMenu() {
      if (_.isEmpty(this.searchFilter)) {
        return []
      }
      let data = _.filter(this.cardsAll, (r) => {
        return _.startsWith(_.trim(_.toLower(r.card_number)), _.trim(_.toLower(this.searchFilter))) ||
            _.startsWith(_.trim(_.toLower(r.rego_number)), _.trim(_.toLower(this.searchFilter))) ||
            _.includes(_.trim(_.toLower(r.customer_name)), _.trim(_.toLower(this.searchFilter)))
      })
      let result = [];
      _.forEach(data, (itm) => {
        let label = itm.card_number
        if (itm.rego_number) {
          label +=  ' - '
        }

        if (itm.rego_number) {
          label += itm.rego_number + ' '
        }

        result.push({
          value: itm.card_id,
          label: label,
          estimateNumber: itm.card_number,
          regoNumber: itm.rego_number,
          customerName: itm.customer_name,
          insurerName: itm.insurance,
          make: itm.make,
          model: itm.model,
          buildDate: itm.dom,
          card_id: itm.card_id,
          pinImageId: itm.pinImageId,
        })
      })
      result = _.orderBy(result, ['label'], ['asc']).slice(0, 10)
      return result
    },
    normalizedTasks() {
      return this.normalizeTasks(this.tasks)
    },
    normalizedComments() {
      return this.normalizeComments(this.comments)
    },
    normalizedCards() {
      return this.normalizeCards(this.cards)
    },
    normalizedEmails() {
      return this.normalizeEmails(this.emails)
    },
    normalizedSms() {
      return this.normalizeSms(this.sms)
    },
    normalizedInsurers() {
      return this.normalizeInsurers(this.insurers)
    },
    phaseOptions() {
      const phases = new Map()
      _.forEach(this.ceStatuses, (status) => {
        const phaseId = status.phaseId || status.phase_id
        const phaseName = status.phaseName || status.phase_name
        if (phaseId && phaseName && !phases.has(phaseId)) {
          phases.set(phaseId, { value: phaseId, label: phaseName })
        }
      })
      return Array.from(phases.values()).sort((a, b) => a.label.localeCompare(b.label))
    },
    inspectionOptions() {
      const specialOption = { value: -100, label: 'Inspection' }
      const statusOptions = _.map(this.ceStatuses, (status) => ({
        value: status.ce_status_id,
        label: status.name || status.status_name
      }))
      return [specialOption, ...statusOptions]
    },
    inspectionsTodayCount() {
      if (!this.selectedInspectionStatus) return 0
      const isInspectionToday = Number(this.selectedInspectionStatus) === -100
      if (isInspectionToday) {
        const today = dayjs().format('YYYY-MM-DD')
        const bookingData = this.bookingItems || []
        const filteredBookings = _.filter(bookingData, (booking) => {
          const isOnsiteToday =  
            booking.onsiteEstimateBookingDate &&
            dayjs(booking.onsiteEstimateBookingDate).format('YYYY-MM-DD') === today
          return isOnsiteToday
        })
        return filteredBookings.length
      } else {
        return _.filter(this.cardsAll, (card) => {
          return Number(card.card_status) === Number(this.selectedInspectionStatus)
        }).length
      }
    },
    estimatesPendingCount() {
      return _.filter(this.getAllEstimates, (estimate) => {
        const amount = estimate.amount
        if (amount === null || amount === undefined) return true
        const numAmount = Number(amount)
        if (numAmount === 0) return true
        if (amount === '0.00') return true
        return false
      }).length
    },
    wipCount() {
      if (!this.selectedWipPhase) return 0
      const phaseStatusIds = _.map(
        _.filter(this.ceStatuses, (status) => {
          const phaseId = status.phaseId || status.phase_id
          return String(phaseId) === String(this.selectedWipPhase)
        }),
        (status) => Number(status.ce_status_id)
      )
      return _.filter(this.cardsAll, (card) => {
        return phaseStatusIds.includes(Number(card.card_status))
      }).length
    },
    avgCycleTime() {
      const ninetyDaysAgo = dayjs().subtract(90, 'days')
      const completedJobs = _.filter(this.cardsAll, (card) => {
        const inDate = this.parseCycleDate(card.booking_date)
        const outDate = this.parseCycleDate(card.completion_date)
        if (!inDate.isValid() || !outDate.isValid()) return false
        return outDate.isAfter(ninetyDaysAgo) && !outDate.isBefore(inDate)
      })
      if (completedJobs.length === 0) return '0'
      const totalDays = _.sumBy(completedJobs, (card) => {
        const inDate = this.parseCycleDate(card.booking_date)
        const outDate = this.parseCycleDate(card.completion_date)
        return outDate.diff(inDate, 'day')
      })
      return (totalDays / completedJobs.length).toFixed(1)
    },
    unreadTasksCount() {
      return _.filter(this.normalizedTasks, (item) => this.isUnread(item)).length
    },
    todoTabs() {
      return [
        { key: 'tasks', label: 'Tasks', count: this.unreadTasksCount ? this.unreadTasksCount + ' New' : '', countClass: 'workcenter-column__count--red' },
        { key: 'comments', label: 'Comments', count: this.normalizedComments.length || '' },
        { key: 'files', label: 'Files', count: this.normalizedCards.length || '' }
      ]
    },
    messageTabs() {
      return [
        { key: 'emails', label: 'Emails', count: this.normalizedEmails.length || '' },
        { key: 'sms', label: 'SMS', count: this.normalizedSms.length || '' },
        { key: 'insurers', label: 'Insurer', count: this.normalizedInsurers.length || '', countClass: 'workcenter-column__count--brand' }
      ]
    },
    insurerFilters() {
      return [
        { key: 'pending_auth', label: 'Pending Auth', count: this.countInsurersByStatus('pending_auth'), className: 'workcenter-filter workcenter-filter--orange' },
        { key: 'auth', label: 'Auth', count: this.countInsurersByStatus('auth'), className: 'workcenter-filter workcenter-filter--green' },
        { key: 'awp', label: 'AWP', count: this.countInsurersByStatus('awp'), className: 'workcenter-filter workcenter-filter--purple' },
        { key: 'excess_change', label: 'Excess Change', count: this.countInsurersByStatus('excess_change'), className: 'workcenter-filter workcenter-filter--teal' }
      ]
    },
    currentTodoSource() {
      if (this.activeTodoTab === 'comments') {
        return this.normalizedComments
      }
      if (this.activeTodoTab === 'files') {
        return this.normalizedCards
      }
      return this.normalizedTasks
    },
    currentMessageSource() {
      if (this.activeMessageTab === 'emails') {
        return this.normalizedEmails
      }
      if (this.activeMessageTab === 'sms') {
        return this.normalizedSms
      }
      return this.filteredInsurers
    },
    filteredInsurers() {
      if (_.isEmpty(this.activeInsurerFilters)) {
        return this.normalizedInsurers
      }
      return _.filter(this.normalizedInsurers, (insurer) => {
        return this.activeInsurerFilters.includes(insurer.status)
      })
    },
    visibleTodoItems() {
      return this.filterItems(this.currentTodoSource, this.todoSearch).slice(0, 12)
    },
    visibleMessageItems() {
      return this.filterItems(this.currentMessageSource, this.messageSearch).slice(0, 12)
    },
    metrics() {
      return [
        { key: 'unread_tasks', title: 'Unread Tasks Assigned', value: this.unreadTasksCount, badge: 'Action Required', color: 'red', options: [] },
        { key: 'inspections_today', title: 'Inspections Today', value: this.inspectionsTodayCount, color: 'green', options: this.inspectionOptions, selectedValue: this.selectedInspectionStatus },
        { key: 'estimates_pending', title: 'Estimates Pending', value: this.estimatesPendingCount, color: 'yellow', options: [] },
        { key: 'wip', title: 'Work In Progress (WIP)', value: this.wipCount, badge: 'Phase: ' + (this.selectedWipPhase ? (this.phaseOptions.find(p => p.value === this.selectedWipPhase)?.label || '') : (this.phaseOptions[0]?.label || '')), color: 'brand', options: this.phaseOptions, selectedValue: this.selectedWipPhase },
        { key: 'avg_cycle_time', title: 'Avg Cycle Time', value: this.avgCycleTime, suffix: 'Days', color: 'purple', options: [] }
      ]
    },
    visibleMetrics() {
      const metrics = this.canViewAdvancedMetrics ? this.metrics : this.metrics.slice(0, 1)
      return metrics.map(metric => {
        if (metric.key === 'inspections_today' && this.selectedInspectionStatus) {
          const selectedOption = this.inspectionOptions.find(opt => opt.value === this.selectedInspectionStatus)
          if (selectedOption) {
            return { ...metric, title: selectedOption.label + ' Today' }
          }
        }
        if (metric.key === 'wip' && this.selectedWipPhase) {
          const selectedOption = this.phaseOptions.find(opt => opt.value === this.selectedWipPhase)
          if (selectedOption) {
            return { ...metric, title: selectedOption.label }
          }
        }
        return metric
      })
    },
    firstNotEmptyNav() {
      return {
        tasks: _.findKey(this.computedTasks, (e) => {return !_.isEmpty(e)}),
        comments: _.findKey(this.computedComments, (e) => {return !_.isEmpty(e)}),
        cards: _.findKey(this.computedCards, (e) => {return !_.isEmpty(e)}),
        emails: _.findKey(this.computedEmails, (e) => {return !_.isEmpty(e)}),
        sms: _.findKey(this.computedSMS, (e) => {return !_.isEmpty(e)}),
        insurers: _.findKey(this.computedInsurers, (e) => {return !_.isEmpty(e)}),
      }
    },
    computedTasks() {
      return this.getNavObject(this.normalizedTasks, 'raw.createdAt', ['title', 'message', 'jobNumber'], this.todoSearch, 'isSortTask')
    },
    computedComments() {
      return this.getNavObject(this.normalizedComments, 'raw.createdOn', ['title', 'message', 'jobNumber'], this.todoSearch, 'isSortComment')
    },
    computedCards() {
      return this.getNavObject(this.normalizedCards, 'raw.sortCreatedDate', ['title', 'message', 'jobNumber'], this.todoSearch, 'isSortCard')
    },
    computedEmails() {
      return this.getNavObject(this.normalizedEmails, 'raw.createdOn', ['title', 'message', 'jobNumber'], this.messageSearch, 'isSortEmail')
    },
    computedSMS() {
      return this.getNavObject(this.normalizedSms, 'raw.smsCreatedOn', ['title', 'message', 'jobNumber'], this.messageSearch, 'isSortSMS')
    },
    computedInsurers() {
      return this.getNavObject(this.filteredInsurers, 'raw.date', ['title', 'message', 'jobNumber'], this.messageSearch, 'isSortInsurers')
    }
  },
  created() {
    if (this.isDisplayBoardUser) {
      this.$router.push('/boards/vehicle-in')
    }
    this.$store.dispatch('board/loadBookingBoard')
  },
  watch: {
    vendorId: {
      immediate: true,
      handler() {
        this.loadStoredMetricOptions()
      }
    }
  },
  methods: {
    goToWorkflow() {
      this.$storage.set("views.cards.defaultView", "board-view");
      this.$router.push('/files')
    },
    getStoredValue(key, fallbackKey) {
      let value = this.$storage.get(key)

      if ((value === null || value === undefined || value === '') && fallbackKey) {
        value = this.$storage.get(fallbackKey)
      }

      return value || null
    },
    loadStoredMetricOptions() {
      this.selectedInspectionStatus = this.getStoredValue(
        this.inspectionStorageKey,
        'workcenter.metric.inspections_today.default'
      )
      this.selectedWipPhase = this.getStoredValue(
        this.wipStorageKey,
        'workcenter.metric.wip.default'
      )
    },
    parseCycleDate(value) {
      if (!value) {
        return dayjs('')
      }

      return dayjs(value, ['DD/MM/YYYY', 'YYYY-MM-DD', 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DDTHH:mm:ssZ'], true)
    },
    redirectToCardEdit(itm) {
      this.$router.push('/files/view/' + itm.value)
    },
    onEnter() {
      if (!_.isEmpty(this.additionalMenu) && !_.isEmpty(this.searchFilter)) {
        if (this.additionalMenu.length == 1) {
          this.redirectToCardEdit(this.additionalMenu[0])
        } else {
          this.$store.commit('setCardFilter', this.searchFilter);
          this.$router.push('/files')
        }
      }
    },
    getNavObject(array, dateField, filters, filter, sortField) {
      let result = {
        today: [],
        yesterday: [],
        thisWeek: [],
        lastWeek: [],
        thisMonth: [],
        lastMonth: [],
        older: [],
      }

      let items = _.orderBy(array, [(itm) => {
        let dateValue = _.get(itm, dateField)
        return dateValue ? new Date(dateValue).getTime() : 0
      }], 'desc')

      _.forEach(items, (item) => {
        if (filter) {
          let isShow = _.some(filters, (f) => {
            return this.isFilteredElement(item[f], filter)
          })
          if (!isShow) {
            return
          }
        }

        let dateValue = _.get(item, dateField)
        if (!dateValue) {
          result.older.push(item)
          return
        }

        let date = dayjs(dateValue)
        let monday = dayjs().isoWeekday(1).format('YYYY-MM-DD')
        let sunday = dayjs().isoWeekday(7).format('YYYY-MM-DD')
        let lastMonday = dayjs().isoWeekday(-6).format('YYYY-MM-DD')
        let lastSunday = dayjs().isoWeekday(0).format('YYYY-MM-DD')

        if (dayjs(date).format('YYYY-MM-DD') == dayjs(new Date()).format('YYYY-MM-DD')) {
          result.today.push(item)
        } else if (dayjs(date).format('YYYY-MM-DD') == dayjs(new Date(new Date().setDate(new Date().getDate()-1))).format('YYYY-MM-DD')) {
          result.yesterday.push(item)
        } else if (dayjs(date).isBetween( dayjs(monday), dayjs(sunday), null, '[]')) {
          result.thisWeek.push(item)
        } else if (dayjs(date).isBetween( dayjs(lastMonday), dayjs(lastSunday), null, '[]')) {
          result.lastWeek.push(item)
        } else if (dayjs(date).month() == new Date().getMonth() && dayjs(date).year() == new Date().getFullYear()) {
          result.thisMonth.push(item)
        } else if (dayjs(date).month() == new Date(new Date().setMonth(new Date().getMonth() - 1)).getMonth() && dayjs(date).year() == new Date(new Date().setMonth(new Date().getMonth() - 1)).getFullYear()) {
          result.lastMonth.push(item)
        } else {
          result.older.push(item)
        }
      })

      if (this[sortField]) {
        result.today = _.orderBy(result.today, [(itm) => {
          let dateValue = _.get(itm, dateField)
          return dateValue ? new Date(dateValue).getTime() : 0
        }], 'asc')
        result.yesterday = _.orderBy(result.yesterday, [(itm) => {
          let dateValue = _.get(itm, dateField)
          return dateValue ? new Date(dateValue).getTime() : 0
        }], 'asc')
        result.thisWeek = _.orderBy(result.thisWeek, [(itm) => {
          let dateValue = _.get(itm, dateField)
          return dateValue ? new Date(dateValue).getTime() : 0
        }], 'asc')
        result.lastWeek = _.orderBy(result.lastWeek, [(itm) => {
          let dateValue = _.get(itm, dateField)
          return dateValue ? new Date(dateValue).getTime() : 0
        }], 'asc')
        result.thisMonth = _.orderBy(result.thisMonth, [(itm) => {
          let dateValue = _.get(itm, dateField)
          return dateValue ? new Date(dateValue).getTime() : 0
        }], 'asc')
        result.lastMonth = _.orderBy(result.lastMonth, [(itm) => {
          let dateValue = _.get(itm, dateField)
          return dateValue ? new Date(dateValue).getTime() : 0
        }], 'asc')
        result.older = _.orderBy(result.older, [(itm) => {
          let dateValue = _.get(itm, dateField)
          return dateValue ? new Date(dateValue).getTime() : 0
        }], 'asc')
      } else {
        result.today = _.orderBy(result.today, [(itm) => {
          let dateValue = _.get(itm, dateField)
          return dateValue ? new Date(dateValue).getTime() : 0
        }], 'desc')
        result.yesterday = _.orderBy(result.yesterday, [(itm) => {
          let dateValue = _.get(itm, dateField)
          return dateValue ? new Date(dateValue).getTime() : 0
        }], 'desc')
        result.thisWeek = _.orderBy(result.thisWeek, [(itm) => {
          let dateValue = _.get(itm, dateField)
          return dateValue ? new Date(dateValue).getTime() : 0
        }], 'desc')
        result.lastWeek = _.orderBy(result.lastWeek, [(itm) => {
          let dateValue = _.get(itm, dateField)
          return dateValue ? new Date(dateValue).getTime() : 0
        }], 'desc')
        result.thisMonth = _.orderBy(result.thisMonth, [(itm) => {
          let dateValue = _.get(itm, dateField)
          return dateValue ? new Date(dateValue).getTime() : 0
        }], 'desc')
        result.lastMonth = _.orderBy(result.lastMonth, [(itm) => {
          let dateValue = _.get(itm, dateField)
          return dateValue ? new Date(dateValue).getTime() : 0
        }], 'desc')
        result.older = _.orderBy(result.older, [(itm) => {
          let dateValue = _.get(itm, dateField)
          return dateValue ? new Date(dateValue).getTime() : 0
        }], 'desc')
      }

      return result
    },
    isFilteredElement(filterText, query) {
      if (!query) {
        return true;
      }
      if (filterText && filterText != '') {
        return (new RegExp(query, 'iug').test(filterText));
      }
      return false;
    },
    selectMetricOption(metricKey, option) {
      if (metricKey === 'inspections_today') {
        this.selectedInspectionStatus = option.value
        this.$storage.set(this.inspectionStorageKey, option.value)
      }
      if (metricKey === 'wip') {
        this.selectedWipPhase = option.value
        this.$storage.set(this.wipStorageKey, option.value)
      }
    },
    toggleInsurerFilter(filterKey) {
      if (this.activeInsurerFilters.includes(filterKey)) {
        this.activeInsurerFilters = this.activeInsurerFilters.filter((key) => key !== filterKey)
        return
      }
      this.activeInsurerFilters = [...this.activeInsurerFilters, filterKey]
    },
    isInsurerFilterActive(filterKey) {
      return this.activeInsurerFilters.includes(filterKey)
    },
    normalizeTasks(items) {
      return _.map(items || [], (item) => ({
        id: item.id,
        raw: item,
        type: 'task',
        title: item.name || item.taskName || 'Task',
        message: item.notesText || item.description || '',
        dateLabel: this.formatDate(item.createdAt || item.dueDate),
        jobNumber: item.cardNumber || item.estimateNumber || '',
        cardId: item.cardId,
        tag: item.priority ? String(item.priority) : '',
        tagColor: String(item.priority || '').toLowerCase() === 'high' ? 'red' : 'blue',
        icon: 'bx bx-task',
        isViewed: item.isViewed
      }))
    },
    normalizeComments(items) {
      return _.map(items || [], (item) => ({
        id: item.id,
        raw: item,
        type: 'comment',
        title: _.get(item, 'task.name') || 'Comment',
        message: item.text || '',
        dateLabel: this.formatDate(item.createdOn),
        jobNumber: _.get(item, 'task.cardNumber') || _.get(item, 'task.estimateNumber') || '',
        tag: '',
        tagColor: 'blue',
        icon: 'bx bx-message-rounded',
        isViewed: item.isViewed
      }))
    },
    normalizeCards(items) {
      return _.map(items || [], (item) => ({
        id: item.card_id || item.id,
        raw: item,
        type: 'card',
        title: item.customer_name || item.card_number || 'File',
        message: [item.make, item.model, item.rego_number].filter(Boolean).join(' '),
        dateLabel: this.formatDate(item.sortCreatedDate || item.created_on),
        jobNumber: item.card_number || '',
        tag: item.priority || '',
        tagColor: String(item.priority || '').toLowerCase() === 'high' ? 'red' : 'blue',
        icon: 'bx bx-file',
        isViewed: item.isViewed
      }))
    },
    normalizeEmails(items) {
      return _.map(items || [], (item) => ({
        id: item.id || item.activityId,
        raw: item,
        type: 'email',
        title: item.from || item.subject || 'Email',
        message: item.subject || item.body || '',
        dateLabel: this.formatDate(item.createdOn),
        jobNumber: item.recipient || '',
        tag: '',
        tagColor: 'blue',
        icon: 'bx bx-envelope',
        isViewed: item.isViewed
      }))
    },
    normalizeSms(items) {
      return _.map(items || [], (item) => ({
        id: item.smsId || item.id,
        raw: item,
        type: 'sms',
        title: item.smsFrom || 'SMS',
        message: item.smsText || '',
        dateLabel: this.formatDate(item.smsCreatedOn),
        jobNumber: item.smsTo || '',
        tag: '',
        tagColor: 'blue',
        icon: 'bx bx-mobile-alt',
        isViewed: item.isViewed
      }))
    },
    normalizeInsurers(items) {
      return _.map(items || [], (item) => {
        let status = this.getInsurerStatus(item)
        return {
          id: item.id,
          raw: item,
          type: 'insurer',
          title: [item.insurerName, item.estimateNumber].filter(Boolean).join(' - ') || 'Insurer',
          message: item.message || '',
          dateLabel: this.formatDate(item.date),
          jobNumber: item.estimateNumber || '',
          tag: this.getInsurerStatusLabel(status),
          tagColor: this.getInsurerStatusColor(status),
          icon: 'bx bx-detail',
          isViewed: item.isViewed,
          status,
          estimateId: item.estimateId || item.estimate_id
        }
      })
    },
    filterItems(items, query) {
      if (!query) {
        return items
      }
      let search = _.toLower(_.trim(query))
      return _.filter(items, (item) => {
        return _.includes(_.toLower([item.title, item.message, item.jobNumber, item.tag].join(' ')), search)
      })
    },
    isUnread(item) {
      let key = item.type + '-' + item.id
      if (Object.prototype.hasOwnProperty.call(this.localReadState, key)) {
        return !this.localReadState[key]
      }
      return !item.isViewed
    },
    openContextMenu(event, item, type) {
      this.contextMenu = {
        visible: true,
        x: event.clientX,
        y: event.clientY,
        item,
        type
      }
    },
    closeContextMenu() {
      this.contextMenu.visible = false
    },
    setReadState(isRead) {
      if (!this.contextMenu.item) {
        return
      }
      const item = this.contextMenu.item
      const raw = item.raw || {}
      let key = item.type + '-' + item.id
      this.$set(this.localReadState, key, isRead)
      
      const payload = {
        activity_id: raw.activityId || raw.activity_id || raw.id || item.id,
        viewed: isRead ? 1 : 0
      }
      
      if (raw.cardId || raw.card_id) {
        payload.card_id = raw.cardId || raw.card_id
      }
      
      this.$store.dispatch('updateActivityViewedStatus', payload)
        .then((response) => {
          if (response && response.data && response.data.msg) {
            toastr.success(response.data.msg)
          }
          if (item.type === 'insurer') {
            this.$store.commit('dashboard/loadInsurers', this.insurers.map(insurer => {
              if (insurer.id === item.id) {
                return { ...insurer, isViewed: isRead ? 1 : 0 }
              }
              return insurer
            }))
          }
        })
        .catch((error) => {
          console.error('Error updating viewed status:', error)
        })
      
      this.closeContextMenu()
    },
    getItemRoute(item) {
      const raw = item.raw || {}
      const type = item.type || this.contextMenu.type

      if (type === 'task') {
        return { name: 'CardsEdit', params: { card_id: raw.cardId || item.cardId }, query: { action: 'goToTask', taskId: raw.id || item.id } }
      }

      if (type === 'comment') {
        return {
          name: 'CardsEdit',
          params: {
            card_id: _.get(raw, 'task.cardId') || item.cardId
          },
          query: {
            action: 'goToComment',
            commentId: raw.id || item.id,
            taskId: _.get(raw, 'task.id')
          }
        }
      }

      if (type === 'card') {
        return { name: 'CardsEdit', params: { card_id: raw.card_id || raw.id || item.id } }
      }

      if (type === 'email') {
        return { name: 'CardsEdit', params: { card_id: raw.cardId || item.cardId }, query: { action: 'goToEmail', emailId: raw.id || item.id } }
      }

      if (type === 'sms') {
        return { name: 'CardsEdit', params: { card_id: raw.cardId || item.cardId }, query: { action: 'goToSms', smsId: raw.smsId || item.id, activityId: raw.activityId || raw.activity_id } }
      }

      if (type === 'insurer') {
        return { name: 'EstimatesEdit', params: { estimate_id: raw.estimateId || item.estimateId }, query: { action: 'goToInsurer', activityId: raw.activityId || raw.activity_id || item.id } }
      }

      return null
    },
    openItemInNewTab() {
      if (!this.contextMenu.item) {
        return
      }
      const route = this.getItemRoute(this.contextMenu.item)
      this.closeContextMenu()
      if (!route) {
        return
      }
      const resolvedRoute = this.$router.resolve(route)
      window.open(resolvedRoute.href, '_blank', 'noopener')
    },
    handleCardClick(item) {
      const route = this.getItemRoute(item)
      if (!route) {
        return
      }
      this.$router.push(route)
    },
    formatDate(value) {
      if (!value) {
        return ''
      }
      let date = dayjs(value)
      if (!date.isValid()) {
        return ''
      }
      if (date.format('YYYY-MM-DD') === dayjs().format('YYYY-MM-DD')) {
        return 'Today ' + date.format('h:mm A')
      }
      return date.format('DD-MMM h:mm A')
    },
    getInsurerStatus(item) {
      let text = _.toLower([item.status, item.statusLabel, item.message].join(' '))
      if (_.includes(text, 'excess')) {
        return 'excess_change'
      }
      if (_.includes(text, 'awp')) {
        return 'awp'
      }
      if (_.includes(text, 'authorised') || _.includes(text, 'authorized') || _.includes(text, 'auth')) {
        return 'auth'
      }
      return 'pending_auth'
    },
    getInsurerStatusLabel(status) {
      return {
        pending_auth: 'Pending Auth',
        auth: 'Authorised',
        awp: 'AWP',
        excess_change: 'Excess Chg'
      }[status]
    },
    getInsurerStatusColor(status) {
      return {
        pending_auth: 'orange',
        auth: 'green',
        awp: 'purple',
        excess_change: 'teal'
      }[status]
    },
    countInsurersByStatus(status) {
      return _.filter(this.normalizedInsurers, { status }).length
    }
  }
}
</script>

<style scoped>
.workcenter-page {
  background: #f4f5f8;
  color: #111827;
  min-height: calc(100vh - 70px);
  padding: 16px 18px;
}

.workcenter-page__topbar {
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
  margin-bottom: 18px;
}

.workcenter-page__topbar h1 {
  color: #111827;
  font-size: 20px;
  font-weight: 700;
  margin: 0;
}

.workcenter-page__breadcrumb {
  color: #5D54EF;
  cursor: pointer;
  font-size: 12px;
  margin-top: 6px;
}

.workcenter-page__actions {
  align-items: center;
  display: flex;
  gap: 8px;
}

.workcenter-metrics-grid {
  display: grid;
  gap: 12px;
  grid-template-columns: 1fr;
  margin-bottom: 16px;
}

.workcenter-columns-grid {
  display: grid;
  gap: 14px;
  grid-template-columns: 1fr;
}

.workcenter-empty {
  color: #6b7280;
  font-size: 12px;
  padding: 16px;
  text-align: center;
}

.workcenter-insurer-filters {
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  gap: 6px;
  overflow-x: auto;
  padding: 7px 8px;
}

.workcenter-filter {
  border-radius: 4px;
  font-size: 9px;
  font-weight: 700;
  padding: 4px 6px;
  white-space: nowrap;
}

.workcenter-filter span {
  border-radius: 3px;
  color: #fff;
  margin-left: 4px;
  padding: 1px 4px;
}

.workcenter-filter--orange { background: #fff7ed; border: 1px solid #ffedd5; color: #c2410c; }
.workcenter-filter--orange span { background: #f97316; }
.workcenter-filter--green { background: #f0fdf4; border: 1px solid #dcfce7; color: #15803d; }
.workcenter-filter--green span { background: #16a34a; }
.workcenter-filter--purple { background: #faf5ff; border: 1px solid #f3e8ff; color: #7e22ce; }
.workcenter-filter--purple span { background: #9333ea; }
.workcenter-filter--teal { background: #f0fdfa; border: 1px solid #ccfbf1; color: #0f766e; }
.workcenter-filter--teal span { background: #0d9488; }
.workcenter-filter--active { box-shadow: 0 0 0 2px rgba(93, 84, 239, 0.28); }

@media (min-width: 768px) {
  .workcenter-metrics-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (min-width: 1200px) {
  .workcenter-metrics-grid {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .workcenter-columns-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 991px) {
  .workcenter-page__topbar,
  .workcenter-page__actions {
    align-items: stretch;
    flex-direction: column;
  }
}
</style>

<style>
.workcenter-metric {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-left-width: 4px;
  border-radius: 3px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  min-height: 70px;
  padding: 13px 16px;
  position: relative;
}

.workcenter-metric--red { border-left-color: #ef4444; }
.workcenter-metric--green { border-left-color: #22c55e; }
.workcenter-metric--yellow { border-left-color: #eab308; }
.workcenter-metric--brand { border-left-color: #5D54EF; }
.workcenter-metric--purple { border-left-color: #a855f7; }

.workcenter-metric__title {
  align-items: center;
  color: #6b7280;
  cursor: default;
  display: flex;
  font-size: 10px;
  font-weight: 700;
  gap: 4px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.workcenter-metric__chevron {
  color: #5D54EF;
  cursor: pointer;
}

.workcenter-metric__body {
  align-items: baseline;
  display: flex;
  gap: 7px;
  margin-top: 6px;
}

.workcenter-metric__value {
  color: #111827;
  font-size: 24px;
  font-weight: 700;
  line-height: 1;
}

.workcenter-metric__value--red {
  color: #dc2626;
}

.workcenter-metric__suffix {
  color: #6b7280;
  font-size: 10px;
  font-weight: 600;
}

.workcenter-metric__badge {
  border-radius: 3px;
  font-size: 8px;
  font-weight: 700;
  padding: 3px 6px;
  text-transform: uppercase;
}

.workcenter-metric__badge--red {
  background: #fef2f2;
  border: 1px solid #fee2e2;
  color: #dc2626;
}

.workcenter-metric__badge--brand {
  background: #EBEAFE;
  border: 1px solid rgba(93, 84, 239, 0.2);
  color: #5D54EF;
}

.workcenter-metric__dropdown {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  box-shadow: 0 10px 18px rgba(0, 0, 0, 0.12);
  left: 20px;
  min-width: 210px;
  overflow: hidden;
  position: absolute;
  top: 44px;
  z-index: 30;
}

.workcenter-metric__dropdown-title,
.workcenter-metric__option {
  font-size: 12px;
  padding: 11px 14px;
}

.workcenter-metric__dropdown-title {
  color: #9ca3af;
  font-weight: 700;
  text-transform: uppercase;
}

.workcenter-metric__option {
  align-items: center;
  background: #fff;
  border: 0;
  color: #374151;
  display: flex;
  justify-content: space-between;
  text-align: left;
  width: 100%;
}

.workcenter-metric__option--active {
  background: #EBEAFE;
  color: #5D54EF;
}

.workcenter-column {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  height: calc(100vh - 270px);
  min-height: 520px;
  overflow: hidden;
}

.workcenter-column__header {
  align-items: center;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  padding: 10px 12px;
}

.workcenter-column__header strong {
  color: #111827;
  font-size: 13px;
  font-weight: 700;
}

.workcenter-column__header .bx {
  color: #9ca3af;
  font-size: 18px;
}

.workcenter-column__header--parts {
  border-top: 4px solid #29bbc1;
}

.workcenter-column__tabs {
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  padding: 0 12px;
}

.workcenter-column__tab {
  align-items: center;
  background: #fff;
  border: 0;
  border-bottom: 2px solid transparent;
  color: #6b7280;
  display: flex;
  flex: 1;
  font-size: 11px;
  font-weight: 600;
  gap: 5px;
  justify-content: center;
  padding: 8px 4px;
}

.workcenter-column__tab--active {
  border-bottom-color: #5D54EF;
  color: #111827;
}

.workcenter-column__tab--parts-active {
  border-bottom-color: #29bbc1;
  color: #111827;
}

.workcenter-column__count {
  background: #f3f4f6;
  border-radius: 8px;
  color: #6b7280;
  font-size: 9px;
  padding: 1px 5px;
}

.workcenter-column__count--red {
  background: #ef4444;
  border-radius: 3px;
  color: #fff;
}

.workcenter-column__count--brand {
  background: #EBEAFE;
  color: #5D54EF;
}

.workcenter-column__count--parts {
  background: rgba(41, 187, 193, 0.15);
  color: #29bbc1;
}

.workcenter-column__search {
  align-items: center;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  gap: 6px;
  padding: 7px 8px;
}

.workcenter-column__search input {
  border: 1px solid #d1d5db;
  border-radius: 3px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  flex: 1;
  font-size: 10px;
  height: 29px;
  outline: 0;
  padding: 0 8px;
}

.workcenter-column__search .bx {
  color: #9ca3af;
}

.workcenter-column__tray {
  background: #f0f2f5;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.06);
  flex: 1;
  overflow-y: auto;
  padding: 8px;
}

.workcenter-list-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 3px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  cursor: pointer;
  margin-bottom: 6px;
  padding: 8px;
}

.workcenter-list-card:hover {
  border-color: #5D54EF;
}

.workcenter-list-card--unread {
  border-left: 2px solid #ef4444;
}

.workcenter-list-card__top {
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

.workcenter-list-card__title-wrap {
  align-items: center;
  display: flex;
  gap: 5px;
  min-width: 0;
}

.workcenter-list-card__title {
  color: #111827;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.workcenter-list-card__date {
  color: #000;
  flex: 0 0 auto;
  font-size: 9px;
  font-weight: 700;
  line-height: 1.1;
}

.workcenter-list-card__meta {
  align-items: center;
  display: flex;
  gap: 6px;
  margin-top: 6px;
}

.workcenter-list-card__job {
  color: #5D54EF;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
}

.workcenter-list-card__message {
  color: #4b5563;
  font-size: 10px;
  line-height: 1.25;
  margin: 5px 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.workcenter-list-card__icon--unread {
  color: #5D54EF;
}

.workcenter-list-card__icon--read {
  color: #d1d5db;
}

.workcenter-list-card__tag {
  border-radius: 3px;
  border: 1px solid transparent;
  font-size: 8px;
  font-weight: 700;
  line-height: 1;
  padding: 3px 5px;
  text-transform: uppercase;
}

.workcenter-list-card__tag--red { background: #fef2f2; border-color: #fecaca; color: #dc2626; }
.workcenter-list-card__tag--blue { background: #eff6ff; border-color: #bfdbfe; color: #1d4ed8; }
.workcenter-list-card__tag--orange { background: #fff7ed; border-color: #fed7aa; color: #c2410c; }
.workcenter-list-card__tag--green { background: #f0fdf4; border-color: #bbf7d0; color: #15803d; }
.workcenter-list-card__tag--purple { background: #faf5ff; border-color: #e9d5ff; color: #7e22ce; }
.workcenter-list-card__tag--teal { background: #f0fdfa; border-color: #99f6e4; color: #0f766e; }
.workcenter-list-card__tag--grey { background: #f3f4f6; border-color: #d1d5db; color: #6b7280; }

.workcenter-context-menu {
  background: #fff;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.16);
  overflow: hidden;
  position: fixed;
  width: 135px;
  z-index: 1000;
}

.workcenter-context-menu button {
  background: #fff;
  border: 0;
  color: #374151;
  display: block;
  font-size: 12px;
  padding: 9px 12px;
  text-align: left;
  width: 100%;
}

.workcenter-context-menu button:hover {
  background: #EBEAFE;
  color: #5D54EF;
}

.workcenter-card-navigation {
  font-size: 12px;
  font-weight: 600;
  padding: 6px 10px;
  color: #5D54EF;
  cursor: pointer;
  user-select: none;
  border-bottom: 1px solid #e5e7eb;
}

.workcenter-card-navigation:hover {
  background: #f9fafb;
}

.workcenter-card-navigation .bx {
  font-size: 16px;
  margin-right: 4px;
}

.workcenter-card-navigation .bx-transfer {
  transform: rotate(90deg);
  margin-left: 8px;
  cursor: pointer;
}

.workcenter-card-navigation .bx-task,
.workcenter-card-navigation .bx-message-rounded,
.workcenter-card-navigation .bx-file,
.workcenter-card-navigation .bx-envelope,
.workcenter-card-navigation .bx-mobile-alt,
.workcenter-card-navigation .bx-detail {
  cursor: pointer;
  margin-left: 8px;
}

.workcenter-card-navigation .bx:hover {
  color: #4c1d95;
}

.workcenter-card-navigation div.active .bxs-chevron-down {
  transform: rotate(180deg);
}

.workcenter-card-navigation .bxs-chevron-down {
  transition: transform 0.2s ease;
}

.d-flex {
  display: flex;
}

.justify-content-between {
  justify-content: space-between;
}
</style>

<style>
@media (max-width: 991px) {
  .workcenter-page__global-search .search-filter__box{
    width: 100% !important;
  }
  .workcenter-page__global-search .search-filter{
    padding-left: 0px !important;
    margin: 0px !important;
  }
}
.workcenter-page__global-search .search-filter__box{
  align-items: center;
  display: flex;
  height: 30px;
  padding: 0 8px;
  width: 260px;
  background: white !important;
  border: 3px solid #5e77fd;
  border-radius: 7px;
}

.workcenter-page__global-search .custom-dropdown{
  left: -144px;
}

.workcenter-page__global-search .search-filter__box__focused{
  border: 3px solid rgba(94, 121, 255, 0.5) !important;
  box-shadow: 0 0 0 0.2rem rgb(94 121 255 / 25%) !important;
}

.workcenter-page__global-search input {
  border: 0;
  font-size: 10px;
  outline: 0;
  padding-left: 6px;
  width: 100%;
}
</style>
